import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import axios from "axios";
import Home from "App/pages/Home";
import Footer from "App/components/Footer";
import About from "App/components/About";
import logo from "assets/logo.svg";
import { getWeatherTexts } from "./utils";
import "./app.scss";

const ToPortal = () => {
  useEffect(() => { window.location.replace("https://portal.digital-giant.com"); }, []);
  return null;
};

const ipApiKey = "at_5fY4UpLc6Rj4hSW2bYmqNFvH3U3Ax";
// const weatherApiKey = "f623eaf187a52afeb9766839a9e2b46c";
const weatherApiKey = "e8ec9de421732b645a439f5bd7bf968f";

const App = () => {
  const [data, setData] = useState(null);
  const [texts, setTexts] = useState(null);
  const [aboutOpen, setAboutOpen] = useState(false);

  useEffect(() => {
    const start = async () => {
      const response = await axios({
        url: "https://geo.ipify.org/api/v1",
        params: { apiKey: ipApiKey }
      });
      setData(response.data);

      const weatherResponse = await axios({
        url: "https://api.openweathermap.org/data/3.0/onecall",
        params: {
          lat: response.data.location.lat,
          lon: response.data.location.lng,
          exclude: "hourly,minutely",
          appid: weatherApiKey
        }
      });

      setTexts([
        `I see you're in ${response.data?.location?.city}`,
        ...getWeatherTexts(weatherResponse.data),
      ]);
    };
    start();
  }, []);

  return (
    <div className="app-container">
      <Router>
        <Routes>
          {/* Client sign-in lives at the DG portal now; the site's old
              login and reset screens are gone. Old links still land well. */}
          <Route path="/login" element={<ToPortal />} />
          <Route path="/reset" element={<ToPortal />} />
          <Route path="/" element={<Home data={data} texts={texts} />} />
        </Routes>

        <div className="page-logo">
          <img src={logo} alt="logo" />
        </div>
        <Footer setAboutOpen={setAboutOpen} />
        <About open={aboutOpen} onClose={() => setAboutOpen(false)} />
      </Router>
    </div>
  );
};

export default App;
